import * as Yup from "yup";

export const retailVoiceSchema = Yup.object().shape({
  image: Yup.string(),
  name: Yup.string().required("Product Name is required"),
  expiryDate: Yup.date().required("Product Expiry Date is required"),
  type: Yup.string(),
  price: Yup.number("Product Price must be more than 0")
    .min(0, "Product Price must be more than 0")
    .required("Product Price is required"),
  tax: Yup.number().required("Product Tax is required"),
  barcode: Yup.string(),
  category: Yup.string().required("Product Category is required"),
  stock: Yup.number()
    .min(0, "Number in stock must be more than 0")
    .required("Number in stock is required"),
  supplier: Yup.string().required("Product supplier is required"),
  measureOfPurchase: Yup.string().required(
    "Product Measure of Purchase is required"
  ),
  measureOfUnit: Yup.string().required("Product Measure of Unit is required"),
  minInStock: Yup.string().required(
    "Product min  of Available Quantity is required"
  ),
});
